import React, { ReactNode } from 'react'
import { Button, Card, Group, Stack } from '@common/ui'

type SemanticLinkFormShellProps = {
  children: ReactNode
  isSaving: boolean
  canSave: boolean
  onSave: () => void
  onCancel: () => void
}

const SemanticLinkFormShell = ({ children, isSaving, canSave, onSave, onCancel }: SemanticLinkFormShellProps) => (
  <Card withBorder data-testid="semantic-link-form">
    <Stack gap="md">
      {children}
      <Group gap="md" justify="flex-end">
        <Button variant="outline" onClick={onCancel} disabled={isSaving}>
          Cancel
        </Button>
        <Button onClick={onSave} disabled={isSaving || !canSave}>
          Save
        </Button>
      </Group>
    </Stack>
  </Card>
)

export default SemanticLinkFormShell
